import dayjs from 'dayjs';

/**
 * Number of trial days before the first subscription charge for the
 * Agentic AI Free Trial 2026 flag-on PDP variant.
 */
export const FREE_TRIAL_LENGTH_IN_DAYS = 7;

/**
 * Returns the date the user will first be charged, formatted as `MMMM D` (e.g. `May 12`).
 * Computed from `from` (defaults to "now") + FREE_TRIAL_LENGTH_IN_DAYS days.
 *
 * Must be called on the client (post-hydration) — the flag-on PDP route uses
 * `getStaticProps` with daily revalidation, so a server-rendered date will drift.
 */
export function getFreeTrialChargeDate(from: Date = new Date()): string {
  return dayjs(from).add(FREE_TRIAL_LENGTH_IN_DAYS, 'day').format('MMMM D');
}
